// extracted by mini-css-extract-plugin
export default {"container":"TableInput_container__kMnka","input":"TableInput_input__u7dq9","total":"TableInput_total__o5K+m"};